module.exports = __webpack_public_path__ + "newsletter-CTA-on-homepage-35652c4cdb15a3a1c8bb.png";